import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import whatsapp from '../images/whatsapp.png';

const OtherServices = () => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('language');
    if (savedLang && ['mr', 'hi', 'en'].includes(savedLang)) {
      setLanguage(savedLang);
    }
  }, []);


  // === TRANSLATIONS ===
  const translations = {
    pageTitle: { mr: 'इतर सेवा', hi: 'अन्य सेवाएँ', en: 'Other Services' },
    sectionTitle: { mr: 'व्यावसायिक आणि समर्पित सेवा', hi: 'पेशेवर और समर्पित सेवाएँ', en: 'Professional & Dedicated Services' },
    services: [
      { name: { mr: 'MSME/SSI नोंदणी/गुंतवणूक', hi: 'MSME/SSI पंजीकरण/निवेश', en: 'MSME/SSI Registration/Investment' } },
      { name: { mr: 'NOC नोंदणी', hi: 'NOC पंजीकरण', en: 'NOC Registration' } },
      { name: { mr: 'MPCB (महाराष्ट्र प्रदूषण नियंत्रण मंडळ)', hi: 'MPCB (महाराष्ट्र प्रदूषण नियंत्रण बोर्ड)', en: 'MPCB (Maharashtra Pollution Control Board)' } },
      { name: { mr: 'FSAAI/Food लायसन्स हॉटेल आणि रेस्टॉरंट साठी/ड्रग लायसन्स', hi: 'FSAAI/Food लाइसेंस होटल और रेस्तरां के लिए/ड्रग लाइसेंस', en: 'FSAAI/Food License for Hotel & Restaurant/Drug License' } },
      { name: { mr: 'बार कोड, ट्रेड मार्क आणि लोगो नोंदणी', hi: 'बार कोड, ट्रेड मार्क और लोगो पंजीकरण', en: 'Bar Code, Trade Mark & Logo Registration' } },
      { name: { mr: 'FWO/श्रम आणि कारखाना लायसन्स', hi: 'FWO/श्रम और फैक्ट्री लाइसेंस', en: 'FWO/Labour & Factory License' } },
      { name: { mr: 'आयात निर्यात लायसन्स', hi: 'आयात निर्यात लाइसेंस', en: 'Import Export License' } },
      { name: { mr: 'Gem नोंदणी', hi: 'Gem पंजीकरण', en: 'Gem Registration' } },
      { name: { mr: 'कीटक नियंत्रण लायसन्स/पासारो लायसन्स', hi: 'कीट नियंत्रण लाइसेंस/पासारो लाइसेंस', en: 'Pest Control License/Pasaro License' } },
      { name: { mr: 'कंपनी नोंदणी (प्रायव्हेट लिमिटेड/व्हॅन पर्सन कंपनी/पब्लिक कंपनी)', hi: 'कंपनी पंजीकरण (प्राइवेट लिमिटेड/वन पर्सन कंपनी/पब्लिक कंपनी)', en: 'Company Registration (Pvt Ltd/OPC/Public Company)' } },
      { name: { mr: 'भागीदारी नोंदणी (वन पर्सन कंपनी/एलएलपी)', hi: 'पार्टनरशिप पंजीकरण (वन पर्सन कंपनी/एलएलपी)', en: 'Partnership Registration (One Person Company/LLP)' } },
      { name: { mr: 'Udyog आधार नोंदणी/ट्रस्ट, सोसायटी आणि फर्म कंपनी', hi: 'उद्योग आधार पंजीकरण/ट्रस्ट, सोसाइटी और फर्म कंपनी', en: 'Udyog Aadhaar Registration/Trust, Society & Firm Company' } },
      { name: { mr: 'MEDHA नोंदणी / MNRE नोंदणी', hi: 'MEDHA पंजीकरण / MNRE पंजीकरण', en: 'MEDHA Registration / MNRE Registration' } },
      { name: { mr: 'RERA नोंदणी', hi: 'RERA पंजीकरण', en: 'RERA Registration' } },
      { name: { mr: 'सॉफ्टवेअर सेवा/वेब डिझाइन डेव्हलपमेंट/वेबसाइट', hi: 'सॉफ्टवेयर सेवा/वेब डिज़ाइन डेवलपमेंट/वेबसाइट', en: 'Software Services/Web Design Development/Website' } },
      { name: { mr: 'प्रोजेक्ट लोन (CC/OD/HL/AP (निधी बँक) प्रोजेक्ट रिपोर्ट', hi: 'प्रोजेक्ट लोन (CC/OD/HL/AP (निधि बैंक) प्रोजेक्ट रिपोर्ट', en: 'Project Loan (CC/OD/HL/AP (Nidhi Bank) Project Report' } },
      { name: { mr: 'प्रोजेक्ट सबसिडी (', hi: 'प्रोजेक्ट सब्सिडी (', en: 'Project Subsidy (' } },
      { name: { mr: 'GST नोंदणी आणि रिटर्न/अकाउंटिंग आणि टॅक्सेशन', hi: 'GST पंजीकरण और रिटर्न/अकाउंटिंग और टैक्सेशन', en: 'GST Registration & Return/Accounting & Taxation' } },
      { name: { mr: 'ESIC/पीएफ आणि पीटी', hi: 'ESIC/पीएफ और पीटी', en: 'ESIC/PF & PT' } },
      { name: { mr: 'इतर सर्व औद्योगिक नोंदणी', hi: 'अन्य सभी औद्योगिक पंजीकरण', en: 'Other All Industrial Registration' } },
    ],
    about: { mr: 'कंपनी बद्दल', hi: 'कंपनी के बारे में', en: 'About Company' },
    companyInfo: { mr: 'ग्लोबल सर्टिफिकेशन इंडिया प्रा. लि.<br>15A, नवजीवन कॉलनी, वर्धा रोड, नरेंद्र नगर, नागपूर-440015', hi: 'ग्लोबल सर्टिफिकेशन इंडिया प्रा. लि.<br>15A, नवजीवन कॉलनी, वर्धा रोड, नरेंद्र नगर, नागपूर-440015', en: 'Global Certification India Pvt. Ltd.<br>Plot No. 15A, Navjeevan Colony, Wardha Road, Narendra Nagar, Nagpur-440015' },
    usefulLinks: { mr: 'उपयुक्त लिंक्स', hi: 'उपयोगी लिंक्स', en: 'Useful Links' },
    others: { mr: 'इतर', hi: 'अन्य', en: 'Others' },
    cta: { mr: 'आमच्याशी संपर्क साधा', hi: 'हमसे संपर्क करें', en: 'Contact Us' },
  };

  const t = (key) => translations[key][language] || translations[key]['en'];

  // === STYLES ===
  const styles = {
    container: {
      fontFamily: "'Poppins', sans-serif",
      backgroundColor: '#fff',
      color: '#333',
      minHeight: '100vh',
      margin: 0,
      padding: 0,
    },
    hero: {
      height: '50vh',
      background: 'linear-gradient(rgba(10,29,86,0.92), rgba(10,29,86,0.92)), url("https://source.unsplash.com/random/1600x900/?consulting,registration")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      color: '#fff',
    },
    heroTitle: {
      fontSize: '2.8rem',
      fontWeight: '700',
      margin: '0 0 8px 0',
      textShadow: '0 4px 12px rgba(0,0,0,0.5)',
    },
    heroSubtitle: {
      fontSize: '1.1rem',
      opacity: 0.9,
    },
    section: {
      padding: '4rem 2rem',
      maxWidth: '1400px',
      margin: '0 auto',
      textAlign: 'center',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
      gap: '1.6rem',
      marginTop: '2rem',
    },
    card: {
      backgroundColor: '#0A1D56',
      color: '#fff',
      padding: '1.6rem 1.2rem',
      borderRadius: '16px',
      fontSize: '0.95rem',
      fontWeight: '500',
      lineHeight: '1.5',
      transition: 'all 0.4s ease',
      boxShadow: '0 6px 18px rgba(10,29,86,0.25)',
      border: '1px solid rgba(255,255,255,0.1)',
      cursor: 'pointer',
    },
    cardHover: {
      transform: 'translateY(-8px)',
      backgroundColor: '#FF7F50',
      boxShadow: '0 16px 32px rgba(255,127,80,0.3)',
    },
    footer: {
      backgroundColor: '#0A1D56',
      color: '#e0e0e0',
      padding: '3rem 2rem 2rem',
      marginTop: '3rem',
      fontSize: '0.9rem',
    },
    footerGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
      gap: '2rem',
      maxWidth: '1200px',
      margin: '0 auto 2rem',
    },
    footerColumn: {
      textAlign: 'left',
    },
    footerTitle: {
      fontSize: '1.1rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#FF7F50',
    },
    footerList: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    footerItem: {
      marginBottom: '0.6rem',
      fontSize: '0.88rem',
      opacity: 0.9,
    },
    footerLink: {
      color: '#e0e0e0',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
    },
    footerLinkHover: {
      color: '#FF7F50',
    },
    copyright: {
      textAlign: 'center',
      fontSize: '0.8rem',
      opacity: 0.7,
      marginTop: '1.5rem',
      paddingTop: '1rem',
      borderTop: '1px solid rgba(255,255,255,0.1)',
    },
    whatsappBtn: {
      position: 'fixed',
      bottom: '1.5rem',
      left: '1.5rem',
      backgroundColor: '#25D366',
      padding: '1rem',
      borderRadius: '50%',
      boxShadow: '0 8px 25px rgba(37,211,102,0.4)',
      zIndex: 1000,
      animation: 'float 3s ease-in-out infinite',
      transition: 'transform 0.2s ease',
    },
    whatsappImg: {
      width: '36px',
      filter: 'brightness(0) invert(1)',
    },
  };

  return (
    <div style={styles.container}>
      {/* Hero */}
      <section style={styles.hero}>
        <h1 style={styles.heroTitle}>{t('pageTitle')}</h1>
        <p style={styles.heroSubtitle}>{t('sectionTitle')}</p>
      </section>

      {/* Services Grid */}
      <section style={styles.section}>
        <div style={styles.grid}>
          {translations.services.map((service, i) => (
            <div
              key={i}
              style={styles.card}
              onMouseEnter={(e) => Object.assign(e.currentTarget.style, styles.cardHover)}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = '';
                e.currentTarget.style.backgroundColor = '#0A1D56';
                e.currentTarget.style.boxShadow = '0 6px 18px rgba(10,29,86,0.25)';
              }}
            >
              {service.name[language]}
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerGrid}>
          {/* About Company */}
          <div style={styles.footerColumn}>
            <h3 style={styles.footerTitle}>{t('about')}</h3>
            <p style={{ lineHeight: '1.6', fontSize: '0.88rem', opacity: 0.9 }} dangerouslySetInnerHTML={{ __html: t('companyInfo') }}></p>
          </div>

          {/* Useful Links */}
          <div style={styles.footerColumn}>
            <h3 style={styles.footerTitle}>{t('usefulLinks')}</h3>
            <ul style={styles.footerList}>
              {[
                { mr: 'होम', hi: 'होम', en: 'Home' },
                { mr: 'आयएसओ प्रमाणने', hi: 'आईएसओ प्रमाणन', en: 'ISO Certification' },
                { mr: 'इतर सेवा', hi: 'अन्य सेवाएँ', en: 'Other Services' },
                { mr: 'क्लायंट्स', hi: 'क्लाइंट्स', en: 'Clients' },
                { mr: 'कंपनी प्रोफाईल', hi: 'कंपनी प्रोफाइल', en: 'Company Profile' },
                { mr: 'व्हिजन मिशन', hi: 'विज़न मिशन', en: 'Vision Mission' },
              ].map((item, i) => (
                <li key={i} style={styles.footerItem}>
                  <Link
                    to="/"
                    style={styles.footerLink}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#FF7F50'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#e0e0e0'}
                  >
                    {item[language]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Others */}
          <div style={styles.footerColumn}>
            <h3 style={styles.footerTitle}>{t('others')}</h3>
            <ul style={styles.footerList}>
              {[
                { mr: 'व्हिडिओ गॅलरी', hi: 'वीडियो गैलरी', en: 'Video Gallery' },
                { mr: 'फोटो गॅलरी', hi: 'फोटो गैलरी', en: 'Photo Gallery' },
                { mr: 'सर्व्हिसेस', hi: 'सर्विसेस', en: 'Services' },
                { mr: 'मेल लॉगिन', hi: 'मेल लॉगिन', en: 'Mail Login' },
                { mr: 'कॉन्टॅक्ट अस', hi: 'संपर्क करें', en: 'Contact Us' },
                { mr: 'लोकेशन्स', hi: 'लोकेशन्स', en: 'Locations' },
              ].map((item, i) => (
                <li key={i} style={styles.footerItem}>
                  <Link
                    to="/"
                    style={styles.footerLink}
                    onMouseEnter={(e) => e.currentTarget.style.color = '#FF7F50'}
                    onMouseLeave={(e) => e.currentTarget.style.color = '#e0e0e0'}
                  >
                    {item[language]}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div style={styles.copyright}>
          © {new Date().getFullYear()} Global Certification  | All Rights Reserved
        </div>
      </footer>

      {/* WhatsApp */}
      <a
        href="https://wa.me/919975977462"
        target="_blank"
        rel="noopener noreferrer"
        style={styles.whatsappBtn}
        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
        onMouseLeave={(e) => e.currentTarget.style.transform = ''}
      >
        <img src={whatsapp} alt="WhatsApp" style={styles.whatsappImg} />
      </a>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
      `}</style>
    </div>
  );
};

export default OtherServices;